















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class ConfirmButton extends Vue {
  @Prop() private classes!: string;
  @Prop({default: 'secondary'}) private color!: string;
  @Prop({default: false}) private isDisabled!: boolean;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: false}) private block!: boolean;
  @Prop({default: false}) private small!: boolean;

}
